// ── MD Product Grid ──
// Reads product data from a Liquid-generated JSON script tag.
// Filters by category (tag match) and metal (gold/silver tag match).
(function() {
  'use strict';

  document.querySelectorAll('.md-products-section').forEach(function(section) {
    var sectionId = section.dataset.sectionId;
    var grid = document.getElementById('mdProductGrid-' + sectionId);
    var filterPills = document.getElementById('mdFilterPills-' + sectionId);
    var metalPills = document.getElementById('mdMetalPills-' + sectionId);

    if (!grid) return;

    // Read product data from Liquid-generated JSON
    var dataEl = document.getElementById('mdProductData-' + sectionId);
    var PRODUCTS = [];
    if (dataEl) {
      try {
        PRODUCTS = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('MD Product Grid: Could not parse product data', e);
      }
    }

    var activeFilter = 'all';
    var activeMetal = 'all';

    // Check if a product matches a metal filter
    // Matches tags containing "gold" or "silver" (e.g., "gold", "gold-builder", "silver-builder")
    function matchesMetal(product, metal) {
      if (metal === 'all') return true;
      if (!product.tags || !product.tags.length) return true;
      var tags = product.tags.map(function(t) { return t.toLowerCase(); });
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].indexOf(metal) !== -1) return true;
      }
      return false;
    }

    // Check if a product matches a category filter
    // Matches against: category field (from Liquid tag matching), product type, or any tag
    function matchesCategory(product, filter) {
      if (filter === 'all') return true;
      var filterLower = filter.toLowerCase();

      // Check Liquid-assigned category
      if (product.category && product.category.toLowerCase() === filterLower) return true;

      // Check product type
      if (product.type && product.type.toLowerCase() === filterLower) return true;
      if (product.sub && product.sub.toLowerCase() === filterLower) return true;

      // Check tags
      if (product.tags && product.tags.length) {
        for (var i = 0; i < product.tags.length; i++) {
          var tagLower = product.tags[i].toLowerCase().replace(/[\s_]/g, '-');
          if (tagLower === filterLower) return true;
        }
      }

      // Check product title contains the filter word
      if (product.name && product.name.toLowerCase().indexOf(filterLower) !== -1) return true;

      return false;
    }

    function renderProducts() {
      var filtered = PRODUCTS.filter(function(p) {
        return matchesCategory(p, activeFilter) && matchesMetal(p, activeMetal);
      });

      if (!filtered.length) {
        grid.innerHTML = '<div class="md-no-results">No products found for this filter.</div>';
        return;
      }

      grid.innerHTML = filtered.map(function(p) {
        var imgHtml = p.img
          ? '<img src="' + p.img + '" alt="' + (p.name || '').replace(/"/g, '&quot;') + '" loading="lazy">'
          : '<div class="md-product-placeholder"><span>' + (p.name || '') + '</span></div>';
        var badgeHtml = p.badge ? '<span class="md-product-badge">' + p.badge + '</span>' : '';
        var priceDisplay = p.price || '';
        var btnLabel = 'Build with this ' + (p.type || 'Item');
        var btnHref;
        if (p.variantId) {
          // Use the same URL pattern as the Product Charm page
          btnHref = '/pages/charm-bar-builder?charm_id=' + p.variantId +
            '&charm_title=' + encodeURIComponent(p.name || '') +
            '&charm_price=' + encodeURIComponent(p.priceRaw || '') +
            '&charm_image=' + encodeURIComponent(p.img || '') +
            '&charm_max_chars=' + (p.maxChars || 0) +
            '&charm_engrave_lines=' + (p.engraveLines || 1);
        } else if (p.handle) {
          btnHref = '/pages/charm-bar-builder?preselect=' + p.handle;
        } else {
          btnHref = p.url || '#';
        }

        return '<div class="md-product-card">' +
          '<div class="md-product-img-wrap">' + imgHtml + badgeHtml + '</div>' +
          '<div class="md-product-info">' +
            '<h3 class="md-product-name">' + (p.name || '') + '</h3>' +

            '<p class="md-product-price">' + priceDisplay + '</p>' +
            '<a href="' + btnHref + '" class="md-btn-atc">' + btnLabel + '</a>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    renderProducts();

    // Category filter pills
    if (filterPills) {
      filterPills.addEventListener('click', function(e) {
        var pill = e.target.closest('.md-filter-pill');
        if (!pill) return;
        filterPills.querySelectorAll('.md-filter-pill').forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');
        activeFilter = pill.dataset.filter;
        renderProducts();
      });
    }

    // Metal pills (Gold / Silver / All)
    if (metalPills) {
      metalPills.addEventListener('click', function(e) {
        var pill = e.target.closest('.md-metal-pill');
        if (!pill) return;
        metalPills.querySelectorAll('.md-metal-pill').forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');
        activeMetal = pill.dataset.metal;
        renderProducts();
      });
    }
  });
})();
